module.exports = __webpack_public_path__ + "img/dropbox.d61507b4.svg";